import { styled } from '@mui/material';

export const ListW = styled('div')`
  position: relative;
  @media (max-width: 1023px) {
    margin-top: 16px;
    padding: 0px 16px 0px 16px;
  }
  background-color: #fbfbfb;
`;

export const SpinnerContainer = styled('div')`
  height: calc(100vh - 178px);
  position: relative;
`;

export const ListTitle = styled('h3')`
  display: flex;
  align-items: center;
  margin: 0px;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-top: 0px;
  @media (max-width: 1023px) {
    line-height: 28px;
  }
`;

export const ToggleText = styled('h3')`
  font-size: 16px;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-top: 0px;
  margin-bottom: 24px;
  @media (max-width: 1023px) {
    line-height: 28px;
    margin-bottom: 16px;
  }
`;

export const InputW = styled('input')`
  width: 20px;
  height: 20px;
`;

export const SliderW = styled('div')`
  margin-bottom: 36px;
`;

export const SliderOuterW = styled('div')`
  display: flex;
  align-items: center;
  align-content: center;
  background-color: #fbfbfb;
  border-radius: 12px;
`;

export const SlideW = styled('div')`
  display: flex;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
  transform: translateZ(0);
  will-change: transform;
  backface-visibility: hidden;
`;

export const PinHeaderContainer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 40px;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const PinToggleButton = styled('button')`
  background-color: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
